import React, { Component } from "react";
import Table from "react-bootstrap/Table";
import { convertToDate } from '../../../../../../utils/helpers.utils';
import { OrderRequestFiles } from "../../request-details-files.component";
import { RequestOnBehalfDetails } from "../../request-on-behalf-details.component";
import Translation from "../../../../../common/translation/translation.component";
import Icons from '../../../../../icon';
import { CIRCUIT_STATUS } from '../../../../../../constants/external-constants';

export class OtherMobileRequestDetails extends Component {
    constructor(props) {
        super(props);
    }

    handleShow = () => {
        this.setState({
            show: true
        });
    }

    componentDidMount = () => {
        this.props.isAllowUpdate()
    }

    render() {
        const { data, isAllowUpdate, openRequestModal } = this.props; 
        const { Order: { RequestType: { RequestTypeID, RequestType } } } = data || {};
        return (
            <div>               
                <h4 className="order-detail-title"><Translation translationKey="order_request_details" />
                    {isAllowUpdate() ?
                         <Icons
                         customClassName="pen-to-square"
                         name="pen-to-square"
                         size="20px"
                         containerClass="icon-circle-plus-container"
                         onClick={() =>{openRequestModal(RequestTypeID, RequestType)}} 
                         labelValue={"Update Order Request"}
                         labelClass="order-detail-edit-label"                                                              
                     />
                        : null
                    }
                </h4>
                <div className="order-detail-location">
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="order_number" />
                        </div>
                        <div className="order-label">
                            {data.Order.OrderNumber}
                        </div>
                    </div>
                    <div className="order-detail-number-container">
                        <div className="order-title">
                            <Translation translationKey="capital_sr_number" />
                        </div>
                        <div className="sr-number-label">
                            {data.Order.ServiceRequestNumber}
                        </div>
                    </div>
                    {data.Order.IsRequestedInBehalf ?
                        <RequestOnBehalfDetails robDetails={data.RequestedInBeHalfOf} isRob={data.Order.IsRequestedInBehalf} />
                        : null}
                    <Table>
                        <tbody>
                            <tr>
                                <td><Translation translationKey="request_only" /></td>
                                <td>{data.Order.RequestType.RequestType}</td>
                            </tr>
                        </tbody>
                    </Table>
                    <h5 className="order-detail-location-title"><Translation translationKey="subscription_upper" /></h5>
                    {data.Circuit.CircuitId != null ?
                    <Table>
                        <tbody>
                            <tr>
                                <td className="mobile-number-label"><Translation translationKey="mobile_phone_number" /></td>
                                <td className="mobile-number-label">{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className={data.Subscription.CircuitStatus == CIRCUIT_STATUS.inService.name ? "status-inservice" : data.Subscription.CircuitStatus == CIRCUIT_STATUS.suspended.name ? "status-suspended" : ""} >{data.Subscription.CircuitStatus}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                    <td className="mobile-number-label">{data.Subscription.VendorName ?
                                        data.Subscription.VendorName :
                                        <Translation translationKey="no_vendor" />}</td>
                            </tr>
                            <tr>
                                <td className="mobile-number-label"></td>
                                    <td className="mobile-number-label">{data.Subscription.PlanDetails.PlanName ?
                                        data.Subscription.PlanDetails.PlanName :
                                        <Translation translationKey="no_plan_available" />}</td>
                            </tr>
                              
                            <tr>
                                <td className="mobile-number-label"></td>
                                <td className="mobile-number-label">{data.Subscription && data.Subscription.SubscriptionDetailDevice ?
                                    data.Subscription.SubscriptionDetailDevice.EquipmentModel :
                                    <Translation translationKey="no_device_available" />} </td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="request_details" /></td>
                                <td>{data.Order.RequestDetails}</td>
                            </tr>
                        </tbody>
                    </Table>
                        :
                    <Table>
                        <tbody>
                            <tr>
                                <td className="mobile-number-label"><Translation translationKey="mobile_phone_number" /></td>
                                <td className="mobile-number-label">{data.Circuit.CircuitCode}</td>
                            </tr>
                            <tr>
                                <td><Translation translationKey="request_details" /></td>
                                <td>{data.Order.RequestDetails}</td>
                            </tr>
                        </tbody>
                    </Table>
                        }
                </div>
            </div>
        );
    }
}